import React from 'react'
import PropTypes from 'prop-types'

import UI5Calendar from "../calendar-v2/calendar-single"
import TimeRange from "core/gd-components/datetime/time-range-picker/time-range/time-range"

import Moment from 'moment'

export default class GDUIDatepickerContent extends React.Component {

    static propTypes = {
        disabledDays        : PropTypes.arrayOf(PropTypes.shape({
            startDate   : PropTypes.object,                    //Moment
            endDate     : PropTypes.object,                      //Moment
            className   : PropTypes.string
        })),

        value               : PropTypes.object,                            // current value (Moment)
        timeRangeValue      : PropTypes.object,                   // current time range value (Moment)

        onSelect            : PropTypes.func,                           // on date selected -> returns moment
        onSelectSomeday     : PropTypes.func,
        onSelectInbox       : PropTypes.func,
        onSelectTimeRange   : PropTypes.func,                  // on time range changed

        // Visualization
        minDate             : PropTypes.object,
        maxDate             : PropTypes.object,

        showTodayButton     : PropTypes.bool,

        addonButtons        : PropTypes.arrayOf(PropTypes.shape({
            label       : PropTypes.string,
            onClick     : PropTypes.func,
            className   : PropTypes.string
        })),

        timeStep            : PropTypes.number,

        showTimeSelector    : PropTypes.bool,
        timeRangeRequired   : PropTypes.bool,
        btnToday            : PropTypes.bool,
        btnTomorrow         : PropTypes.bool,
        btnSomeday          : PropTypes.bool,
        btnInbox            : PropTypes.bool,
        btnNoValue          : PropTypes.bool,
        btnNoValueLabel     : PropTypes.string,
        customButtonsNoBg   : PropTypes.bool,

        disabled            : PropTypes.bool
    };

    classMain = "gd-datepicker-new";

    setToToday          = () => {if (this.props.onSelect) this.props.onSelect(Moment())}
    setToTomorrow       = () => {if (this.props.onSelect) this.props.onSelect(Moment().add(1,"day"))}
    setToSomeday        = () => {if (this.props.onSelectSomeday) this.props.onSelectSomeday()}
    setToInbox          = () => {if (this.props.onSelectInbox) this.props.onSelectInbox()}
    setToNone           = () => {if (this.props.onSelect) this.props.onSelect(null)}
    onChangeTimeRange   = (range) => {if (this.props.onSelectTimeRange) this.props.onSelectTimeRange(range)}

    render() {

        const buttons = []
        if (this.props.btnNoValue)  buttons.push({label: this.props.btnNoValueLabel,            onClick: this.setToNone})
        if (this.props.btnInbox)    buttons.push({label: "Inbox",       icon: 'i5-inbox',       onClick: this.setToInbox})
        if (this.props.btnToday)    buttons.push({label: "Today",       icon: 'i5-date-star',   onClick: this.setToToday})
        if (this.props.btnTomorrow) buttons.push({label: "Tomorrow",    icon: 'i5-date-start',  onClick: this.setToTomorrow})
        if (this.props.btnSomeday)  buttons.push({label: "Someday",     icon: 'i5-someday',     onClick: this.setToSomeday,   className: "someday-button"})

        const customButtons = this.props.addonButtons ? buttons.concat(this.props.addonButtons) : buttons

        const selectedDays = this.props.value ? [{startDate: this.props.value}] : null
        const classes = Classes(this.classMain+"-calendar", this.props.className, {
            disabled: this.props.disabled
        })

        return (
            <div className={classes}>

                <UI5Calendar selectedDays       = {selectedDays}
                             disabledDays       = {this.props.disabledDays}
                             onSelect           = {this.props.onSelect}
                             minDate            = {this.props.minDate}
                             maxDate            = {this.props.maxDate}
                             showTodayButton    = {this.props.showTodayButton}
                             customButtons      = {customButtons}
                             customButtonsNoBg  = {this.props.customButtonsNoBg}/>

                {(this.props.timeRangeRequired || this.props.showTimeSelector) &&
                    <TimeRange timeRangeValue   = {this.props.timeRangeValue}
                               timeStep         = {this.props.timeStep}
                               deleteAllowed    = {!this.props.timeRangeRequired}
                               onChange         = {this.onChangeTimeRange}/>}
            </div>
        )
    }
}
